import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { MedicationRedLabelActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-medication-red-label-slot-v2',
    templateUrl: './medication-red-label-slot-v2.component.html',
    styleUrl: './medication-red-label-slot-v2.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedicationRedLabelSlotComponentV2 implements SheetSlotComponentBase {

	action!: MedicationRedLabelActionV2;
	value!: string | null;

	@Input('action') set updateAction(action: MedicationRedLabelActionV2 | null) {
		this.action = action as MedicationRedLabelActionV2;
		this.value = this.action.amountGiven?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}